<template>
  <div class="field-item">
    <div class="field-label">
      {{ field.label }}<i v-if="field.fill_status" class="impor">*</i>
    </div>
    <div class="field-control">
      <el-input
        v-model="inner"
        :placeholder="field.prompt || ''"
        :maxlength="field.maxlength || 200"
        show-word-limit
        clearable
        @input="$emit('input', inner)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldText',
  props: { field: Object, value: { default: '' } },
  data () { return { inner: this.value || '' } },
  watch: { value (v) { this.inner = v || '' } }
}
</script>
